import React, { type FC } from 'react';
import PropTypes from 'prop-types';

import { Link } from '@confluence/route-manager/entry-points/Link';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context';
import { isTeamsAppEnabled } from '@confluence/teams-app-config/entry-points/isTeamsAppEnabled';

export const PeopleLink: FC<any> = (props) => {
	const { href, to, ...otherProps } = props;
	const url = to || href;
	const path = url && url.indexOf('/') !== 0 ? `/${url}` : url;
	const destination = !path.startsWith(CONTEXT_PATH) ? `${CONTEXT_PATH}${path}` : path;

	// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
	return <Link {...props} href={isTeamsAppEnabled() ? url : destination} {...otherProps} />;
};

PeopleLink.propTypes = {
	href: PropTypes.string,
	to: PropTypes.string,
};
